<template>
  <div class="nettdoc-breathing-problems-detail">
    <SectionHeader 
      text="I have breathing problems" 
      img="illu-card-beschwerden-breath" 
      alt="Lung for breathing problems" 
      :collapsable="true" 
      v-on:collapse="collapsed = !collapsed"
      :complete="store.breathingProblemsDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader text="Since when do you have an issue breathing?" :dark="true" :required="true" />
      <Dropdown 
        label="please choose"
        :data="['1 day', '2 to 6 days', 'More than one week', '1 month', 'Always']"
        :choice="store.breathingProblemsDetails.since"
        v-on:action="value => store.addBreathingProblemsDetails('since', value)"
      />

      <SectionHeader text="breathShortage" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.breathShortage"
        v-on:action="value => store.addBreathingProblemsDetails('breathShortage', value)"
      />
      <SectionHeader text="stopBreathingAtNight" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.stopBreathingAtNight"
        v-on:action="value => store.addBreathingProblemsDetails('stopBreathingAtNight', value)"
      />
      <SectionHeader text="problemsSleeping" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.problemsSleeping"
        v-on:action="value => store.addBreathingProblemsDetails('problemsSleeping', value)"
      />
      <SectionHeader text="onlySleepWhileSitting" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.onlySleepWhileSitting"
        v-on:action="value => store.addBreathingProblemsDetails('onlySleepWhileSitting', value)"
      />
      <SectionHeader text="veryLoudSnore" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.veryLoudSnore"
        v-on:action="value => store.addBreathingProblemsDetails('veryLoudSnore', value)"
      />
      <SectionHeader text="swollenLegs" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.swollenLegs"
        v-on:action="value => store.addBreathingProblemsDetails('swollenLegs', value)"
      />

      <SectionHeader text="breathShortageWhen" :dark="true" :required="false" />
      <Dropdown 
        label="please choose"
        :data="['Excercising physically', 'At night or while lying down']"
        :choice="store.breathingProblemsDetails.breathShortageWhen"
        v-on:action="value => store.addBreathingProblemsDetails('breathShortageWhen', value)"
      />

      <SectionHeader text="cough" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.cough"
        v-on:action="value => store.addBreathingProblemsDetails('cough', value)"
      />
      <template v-if="store.breathingProblemsDetails.cough === 'yes'">
        <Dropdown 
          label="please choose"
          :data="['Dry cough', 'Nervous cough', 'Cough with sputum', 'Spasmadic cough']"
          :choice="store.breathingProblemsDetails.coughHow"
          v-on:action="value => store.addBreathingProblemsDetails('coughHow', value)"
        />
        <SectionHeader text="coughWhen" :dark="true" :required="false" />
        <Dropdown 
          label="please choose"
          :data="['At night', 'In the morning', 'During the day / at noon', 'In the evening', 'Always', 'Only lying down']"
          :choice="store.breathingProblemsDetails.coughWhen"
          v-on:action="value => store.addBreathingProblemsDetails('coughWhen', value)"
        />
      </template>

      <SectionHeader text="raspy" :dark="true" :required="false" />
      <YesNo 
        :model="store.breathingProblemsDetails.raspy"
        v-on:action="value => store.addBreathingProblemsDetails('raspy', value)"
      />
      <SectionHeader text="tabacco" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.tabacco"
        v-on:action="value => store.addBreathingProblemsDetails('tabacco', value)"
      />
      <SectionHeader text="breathShortageWhileExercising" :dark="true" :required="false" />
      <YesNo 
        :model="store.breathingProblemsDetails.breathShortageWhileExercising"
        v-on:action="value => store.addBreathingProblemsDetails('breathShortageWhileExercising', value)"
      />
      <SectionHeader text="breathShortageWhileNotMoving" :dark="true" :required="false" />
      <YesNo 
        :model="store.breathingProblemsDetails.breathShortageWhileNotMoving"
        v-on:action="value => store.addBreathingProblemsDetails('breathShortageWhileNotMoving', value)"
      />
      <SectionHeader text="pressureOnRibcage" :dark="true" :required="true" />
      <YesNo 
        :model="store.breathingProblemsDetails.pressureOnRibcage"
        v-on:action="value => store.addBreathingProblemsDetails('pressureOnRibcage', value)"
      />
      <template v-if="store.breathingProblemsDetails.pressureOnRibcage === 'yes'">
        <SectionHeader text="pressureOnRibcageWhen" :dark="true" :required="false" />
        <Dropdown 
          label="please choose"
          :data="['Being physically active or having stress', 'While resting']"
          :choice="store.breathingProblemsDetails.pressureOnRibcageWhen"
          v-on:action="value => store.addBreathingProblemsDetails('pressureOnRibcageWhen', value)"
        />
      </template>

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.breathingProblemsDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import Button from "../Button";
import Dropdown from "../Dropdown";
export default observer({
    name: 'BreathingProblems',
    data() {
      return {
        collapsed: true
      };
    },
    props: {
      store: Object,
      edit: Boolean
    },
    components: {
      SectionHeader, YesNo, Button, Dropdown
    },
    methods: {
    submit: function() {
      this.store.breathingProblemsDetails.submitted = true
      localStorage.setItem(
        "breathingProblemsDetails",
        JSON.stringify(this.store.breathingProblemsDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>

</style>